<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "SKUIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
